import { stat } from 'fs';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getNewsfeeds,
  getNewsfeedsClear,
  getNewsfeedsIdle,
} from 'store/ducks/newsfeeds/actions';
import { newsfeedsSelector } from 'store/ducks/newsfeeds/selectors';
import {
  Media,
  Btn,
  Subscription,
  ArticlePostVideo,
  PageMeta,
} from '../../components';
import MaterialsLink from './components/materialsLink';
import PostVideoLink from './components/postVideoLink';
import ArticlesPost from './components/articlesPost';

import './AuthorPosts.css';
import {
  selectPosition7Banner,
  selectPosition8Banner,
  selectPosition9Banner,
} from 'store/ducks/banners/selectors';

export default function AuthorPosts({ match }: { match: any }) {
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);

  const status = useSelector(
    (state: { newsfeeds: { status: string } }) => state.newsfeeds.status
  );
  const titlePage = useSelector(
    (state: { newsfeeds: { title: string } }) => state.newsfeeds.title
  );
  const newsfeeds = useSelector(newsfeedsSelector);
  const newsfeedsPaginate = useSelector(
    (state: { newsfeeds: { paginate: any } }) => state.newsfeeds.paginate
  );

  const position7Banner = useSelector(selectPosition7Banner);
  const position8Banner = useSelector(selectPosition8Banner);
  const position9Banner = useSelector(selectPosition9Banner);

  useEffect(() => {
    if (status == 'SUCCESS') {
      dispatch(getNewsfeedsIdle());
    }
  }, [status]);

  useEffect(() => {
    setPage(0);
    dispatch(getNewsfeedsClear());
  }, []);

  useEffect(() => {
    setPage(0);
    dispatch(getNewsfeedsClear());

    dispatch(
      getNewsfeeds({
        taxonomy: match.params.author,
        type: 'author',
      })
    );
  }, [match.params.author]);

  let indexPost = 0;

  const addIndex = (i: number) => {
    indexPost = i + 1;
  };

  return (
    <>
      <PageMeta
        title={titlePage}
        description="Telesputnik.ru является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента."
      />
      <main className="page page-newsfeed container container--page">
        <div className="page-newsfeed__header">
          <h1 className="page-title page-newsfeed__page-title">{titlePage}</h1>
        </div>
        {newsfeeds && newsfeeds.length > 0 && (
          <div className="page-newsfeed__body">
            {(newsfeeds[indexPost] && newsfeeds[indexPost].isVideo && (
              <div className="card card--l">
                <ArticlePostVideo {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </div>
            )) || (
              <div className="card card--l">
                <article className="post-video others__post-video">
                  <PostVideoLink {...newsfeeds[indexPost]} isCategory={false} />
                  {addIndex(indexPost)}
                </article>
              </div>
            )}
            {newsfeeds[indexPost] && (
              <div className="card card--l">
                <article className="post-video others__post-video">
                  <PostVideoLink {...newsfeeds[indexPost]} isCategory={false} />
                  {addIndex(indexPost)}
                </article>
              </div>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {(newsfeeds.length > 3 && position7Banner && (
              <div className="card card--m">
                {(position7Banner.html && position7Banner.html !== '' && (
                  <>{position7Banner.html}</>
                )) || (
                  <a
                    href={position7Banner.url}
                    className="materials__link"
                    target="_blank"
                  >
                    <div className="promo others__promo">
                      <img
                        className="promo__img"
                        src={position7Banner.img}
                        alt="#"
                      />
                    </div>
                  </a>
                )}
              </div>
            )) || (
              <>
                {newsfeeds[indexPost] && (
                  <article className="card card--m">
                    <MaterialsLink {...newsfeeds[indexPost]} />
                    {addIndex(indexPost)}
                  </article>
                )}
              </>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {(newsfeeds[indexPost] || newsfeeds[indexPost + 1]) && (
              <div className="card card--xl">
                <div className="card__wrapper">
                  {newsfeeds[indexPost] && (
                    <article className="post post--articles articles__post">
                      <ArticlesPost {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  )}
                  {newsfeeds[5] && (
                    <article className="post post--articles post--articles-yellow articles__post">
                      <ArticlesPost {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  )}
                </div>
              </div>
            )}
            {(newsfeeds.length > 6 && position9Banner && (
              <div className="card card--xl-v">
                <div className="promo articles__promo">
                  {(position9Banner.html && position9Banner.html !== '' && (
                    <>{position9Banner.html}</>
                  )) || (
                    <a href={position9Banner.url} target="_blank">
                      <img
                        className="promo__img"
                        src={position9Banner.img}
                        alt="#"
                      />
                    </a>
                  )}
                  {/* <div className="tag tag--white tag--mobile">
                                        Реклама
                                    </div> */}
                </div>
              </div>
            )) ||
              (newsfeeds.length > 6 && (
                <div className="card card--xl-v">
                  <MaterialsLink isCategory={false} {...newsfeeds[indexPost]} />
                  {addIndex(indexPost)}
                </div>
              ))}
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink isCategory={false} {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink isCategory={false} {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink isCategory={false} {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {(newsfeeds.length > 9 && position8Banner && (
              <div className="card card--m">
                {(position8Banner.html && position8Banner.html !== '' && (
                  <>{position8Banner.html}</>
                )) || (
                  <a href={position8Banner.url} className="materials__link">
                    <div className="promo others__promo">
                      <img
                        className="promo__img"
                        src={position8Banner.img}
                        alt="#"
                      />
                    </div>
                  </a>
                )}
              </div>
            )) ||
              (newsfeeds.length > 9 && (
                <div className="card card--m">
                  {newsfeeds[indexPost] && (
                    <article className="card card--m">
                      <MaterialsLink {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  )}
                </div>
              ))}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            <div className="card card--xxl">
              <Subscription page="page-newsfeed" mod="" />
            </div>
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds.length > 15 &&
              newsfeeds.map((item, index) => {
                if (index > 14) {
                  return (
                    <article className="card card--m" key={item.id}>
                      {/* {(item.isVideo && (
                                                <ArticlePostVideo
                                                    {...item}
                                                    isShowTag={false}
                                                />
                                            )) || <MaterialsLink {...item} />} */}
                      <MaterialsLink {...item} />
                    </article>
                  );
                }
              })}
          </div>
        )}
        {newsfeedsPaginate &&
          newsfeedsPaginate.total_pages !== newsfeedsPaginate.current_page && (
            <Btn
              mod=""
              type="page-newsfeed"
              handleClick={(e: any) => {
                e.preventDefault();

                if (status == 'IDLE') {
                  setPage(page + 1);

                  let taxonomy = 0,
                    type = 'author';
                  if (match.params.author) {
                    taxonomy = match.params.author;
                  }

                  dispatch(
                    getNewsfeeds({
                      taxonomy: taxonomy,
                      type: type,
                      page: page + 1,
                    })
                  );
                }
              }}
            >
              Больше материалов
            </Btn>
          )}
        <div className="clear"></div>
        {/* <Media /> */}
      </main>
    </>
  );
}
